import React from "react";
import PropTypes from "prop-types";

import { Button, Dropdown } from "semantic-ui-react";

import { useSync } from "data/hub/sync";

import Tooltip from "components/Tooltip";

function ConnectCRMButton({ connected, canConnect, options, onClick }) {
  const { syncInProgress } = useSync();

  const getTooltipTitle = () => {
    if (!canConnect) {
      return "You cannot connect multiple CRMs to your Hubly account";
    }

    return `You cannot ${
      connected ? "reset your credentials" : "connect to this app"
    } while a CRM sync is in progress`;
  };

  return (
    <Button.Group>
      <Tooltip title={getTooltipTitle()} hidden={canConnect && !syncInProgress}>
        <div style={{ display: "inline-block" }}>
          <Button onClick={onClick} disabled={syncInProgress || !canConnect}>
            {connected ? "Reset Credentials" : "Connect"}
          </Button>
        </div>
      </Tooltip>

      {options.length > 0 && (
        <Dropdown className="button icon" floating options={options} />
      )}
    </Button.Group>
  );
}

ConnectCRMButton.propTypes = {
  connected: PropTypes.bool,
  canConnect: PropTypes.bool,
  options: PropTypes.array,
  onClick: PropTypes.func.isRequired,
};

ConnectCRMButton.defaultProps = {
  connected: false,
  canConnect: false,
  options: [],
};

export default ConnectCRMButton;
